import { ColumnProps } from 'common/components/Flex/types';
import Flex from 'common/components/Flex/Flex.tsx';

const Col = ({ children, ...rest }: ColumnProps) => (
  <Flex {...rest} row={false}>
    {children}
  </Flex>
);

export default Col;
